import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import SubmitButton from '../../components/SubmitButton/SubmitButton';
import Logo from '../../assets/svgs/Logo';
import termsOfServiceIllustration from '../../assets/images/healthscan-register-illustration.svg';
import translate from '../../libs/i18n';

import { TermsOfServiceStyle } from './TermsOfServiceStyle';

const TermsOfService = () => {
  const language = useSelector((state) => state.settings.language);

  return (
    <TermsOfServiceStyle>
      <section className="terms-of-service-section">
        <div className="terms-of-service-content">
          <div className="terms-of-service-head">
            <h1 className="terms-of-service-head-title">
              {translate('termsOfServiceTitle', language)}
            </h1>
            <p className="terms-of-service-head-description">
              {translate('termsOfServiceDescription', language)}
            </p>
          </div>

          <div className="terms-of-service-container">
            <div className="terms-of-service-container-content">
              <div
                className="terms-of-service-container-description"
                style={{ whiteSpace: 'pre-line' }}
              >
                {translate('termsOfService', language)}
              </div>
            </div>
          </div>
        </div>
      </section>
    </TermsOfServiceStyle>
  );
};

TermsOfService.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  theme: PropTypes.string,
};

TermsOfService.defaultProps = {
  isOpen: false,
  onClose: () => {},
  theme: 'light',
};

export default TermsOfService;
